export interface EvaluatorCategoryDetail {
  dtConclusaoAvaliacao?: string | null;
  idCategoria: number;
  nomCategoria: string;
  numHistoriasAvaliadas: number;
  numHistoriasTotal: number;
}

export interface EvaluatorDetail {
  idAvaliador: number;
  nomAvaliador: string;
  dtUltimaAvaliacao?: string | null;
  numDiasFimAvaliacao?: number | null;
  categorias: EvaluatorCategoryDetail[];
  dtConclusaoAvaliacao?: string | null;
}

export interface EvaluatorStoryCriterion {
  idClassificacaoCriterioCategoria: number;
  numOrdemExibicao: number;
  desTitulo: string;
  desCriterio: string;
  numNota: number | null;
}

export interface EvaluatorStoryItem {
  criterios: EvaluatorStoryCriterion[];
  idHistoria: number;
  idCategoria: number;
  nomCategoria: string;
  desTituloHistoria: string;
  numNotaCriterio1: number;
  numNotaCriterio2: number;
  numNotaCriterio3: number;
  numNotaCriterio4: number;
  numNotaTotal: number;
}

export interface ClassificationStoryItem {
  idHistoria: number;
  tpHistoria: string;
  desTituloHistoria: string;
  nomDonoHistoria: string;
  nomPessoaCadastro: string;
  nomCategoria: string;
  nomEspacoOcupacional: string;
  identificacaoUf: string;
  dtEnvio: string;
  stHistoria: string;
  indClassificacaoRealizadaAdmin: boolean;
  nomPessoaClassificacao: string;
  numNotaClassificacao: number;
}

export type EvaluatorStorySortField =
  | 'criterio'
  | 'titulo'
  | 'criterio1'
  | 'criterio2'
  | 'criterio3'
  | 'criterio4'
  | 'notaTotal';

export type SortType = 'ASC' | 'DESC';

export const EVALUATOR_STORY_LISTING_TYPES = [
  'TODAS',
  'NAO_AVALIADAS',
  'AVALIADAS',
] as const;

export type EvaluatorStoryListingType =
  (typeof EVALUATOR_STORY_LISTING_TYPES)[number];

export interface EvaluatorStoriesFilter {
  pageIndex?: number;
  pageSize?: number;
  sortField?: EvaluatorStorySortField;
  sortType?: SortType;
  numOrdemCriterioOrdenacao?: number;
  idCiclo?: number;
  idAvaliador?: number;
  idCategoria?: number;
  tpListagem?: EvaluatorStoryListingType;
  desTituloHistoria?: string;
}
